/**
 * Conflito de janela de exibição (avisos) — sobreposição [início, término].
 * Espelha a regra de backend/services/users-customers/vcNoticeUtils.js
 */

export function localPartsToDate(dateYmd, hour, minute) {
  if (!dateYmd) return null;
  const [y, m, d] = String(dateYmd)
    .split('-')
    .map((x) => parseInt(x, 10));
  if (!y || !m || !d) return null;
  const h = Math.min(23, Math.max(0, parseInt(hour, 10) || 0));
  const min = Math.min(59, Math.max(0, parseInt(minute, 10) || 0));
  return new Date(y, m - 1, d, h, min, 0, 0);
}

export function endOfLocalDay(dateYmd) {
  if (!dateYmd) return null;
  const [y, m, d] = String(dateYmd)
    .split('-')
    .map((x) => parseInt(x, 10));
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d, 23, 59, 59, 999);
}

export function isoToLocalDate(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** Sem expiresAt: fim do dia local do início. */
export function resolveLocalDisplayWindow(publishAtIsoOrDate, expiresAtIsoOrDate) {
  const start =
    publishAtIsoOrDate instanceof Date
      ? publishAtIsoOrDate
      : isoToLocalDate(publishAtIsoOrDate);
  if (!start) return null;
  let end =
    expiresAtIsoOrDate instanceof Date
      ? expiresAtIsoOrDate
      : isoToLocalDate(expiresAtIsoOrDate);
  if (!end) {
    end = new Date(start.getFullYear(), start.getMonth(), start.getDate(), 23, 59, 59, 999);
  }
  if (end.getTime() <= start.getTime()) {
    end = new Date(start.getTime() + 60 * 1000);
  }
  return { start, end };
}

export function rangesOverlap(aStart, aEnd, bStart, bEnd) {
  if (!aStart || !bStart || !aEnd || !bEnd) return false;
  return aStart.getTime() < bEnd.getTime() && bStart.getTime() < aEnd.getTime();
}

export function findDisplayWindowConflict(candidate, others = []) {
  const cand = resolveLocalDisplayWindow(candidate?.publishAt, candidate?.expiresAt);
  if (!cand) return null;
  for (const other of others || []) {
    const win = resolveLocalDisplayWindow(other.publishAt, other.expiresAt);
    if (!win) continue;
    if (rangesOverlap(cand.start, cand.end, win.start, win.end)) return other;
  }
  return null;
}

/** True se a janela do slot intersecta o dia civil local ymd (YYYY-MM-DD). */
export function slotTouchesLocalDay(slot, ymd) {
  const win = resolveLocalDisplayWindow(slot?.publishAt, slot?.expiresAt);
  if (!win || !ymd) return false;
  const dayStart = localPartsToDate(ymd, 0, 0);
  const dayEnd = endOfLocalDay(ymd);
  if (!dayStart || !dayEnd) return false;
  return rangesOverlap(win.start, win.end, dayStart, dayEnd);
}
